export const initialState = {};

export default function railsContextReducer(state = initialState) {
  return state;
}
